const texte = (valeur) => String(valeur ?? "").trim();

export const VUES_DEVIS = ["ACTIFS", "ARCHIVES", "TOUS"];
export const TRIS_DEVIS = ["RECENT", "ANCIEN", "NUMERO", "STATUT"];

export function filtrerEtTrierDevis(devis = [], vue = "ACTIFS", recherche = "", tri = "RECENT") {
  const terme = texte(recherche).toLocaleLowerCase("fr");
  const resultat = devis.filter((item) => {
    if (vue === "ACTIFS" && item.archive) return false;
    if (vue === "ARCHIVES" && !item.archive) return false;
    if (!terme) return true;
    return [item.numero_devis, item.titre, item.statut]
      .some((valeur) => texte(valeur).toLocaleLowerCase("fr").includes(terme));
  });
  return [...resultat].sort((a, b) => {
    if (tri === "ANCIEN") return texte(a.date_creation).localeCompare(texte(b.date_creation)) || texte(a.numero_devis).localeCompare(texte(b.numero_devis), "fr");
    if (tri === "NUMERO") return texte(a.numero_devis).localeCompare(texte(b.numero_devis), "fr", { numeric: true });
    if (tri === "STATUT") return texte(a.statut).localeCompare(texte(b.statut), "fr") || texte(b.date_creation).localeCompare(texte(a.date_creation));
    return texte(b.date_creation).localeCompare(texte(a.date_creation)) || texte(b.numero_devis).localeCompare(texte(a.numero_devis), "fr", { numeric: true });
  });
}

export function messageDependanceSuppression(resultat) {
  const premiere = resultat?.dependances?.[0];
  if (!premiere) return "Ce devis possède une relation métier protégée. Il ne peut pas être supprimé. Vous pouvez l’archiver.";
  const reference = premiere.reference ? ` ${premiere.reference}` : "";
  return `Ce devis est utilisé par ${premiere.libelle}${reference}. Il ne peut pas être supprimé. Vous pouvez l’archiver.`;
}

